import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ReportButton from "@/components/feature/fyai-report-button";

function AppShell() {
  const location = useLocation();
  const hideReportButton = location.pathname.startsWith("/report");

  return (
    <>
      <AppRoutes />
      {!hideReportButton && <ReportButton />}
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppShell />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;